import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse, HttpEventType } from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { catchError, finalize, tap } from "rxjs/operators";
import { SnackbarService } from "../../components/snackbar/service/snackbar.service";
import { I18nService } from "../../i18n/service/i18n.service";
import { NavigationExtras, Router } from "@angular/router";
import { SNACKBAR_CLASS } from "../../components/snackbar/model/snackbar.model";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { LoadingService } from "../../service/loading/loading.service";

export class HttpError {
  static BadRequest = 400;
  static Unauthorized = 401;
  static Forbidden = 403;
  static NotFound = 404;
  static TimeOut = 408;
  static Conflict = 409;
  static InternalServerError = 500;
  static GatewayTimeout = 504;
}

export const InterceptorSkip = 'X-Skip-Interceptor';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public static tmpDebounceFlag = false;

  constructor(
    private snack: SnackbarService,
    private i18n: I18nService,
    private router: Router,
    private auth: RfAuthenticationService,
    private loading: LoadingService
  ) {}

  openSnack(message: string, type: string) {
    const snackData: any = {};
    snackData.message = message;
    snackData.type = type;
    this.snack.openSnackBar(snackData);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let lastResponse: HttpEvent<any>;
    let error: HttpErrorResponse;

    if (req.headers && req.headers.has(InterceptorSkip)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap((response: HttpEvent<any>) => {
        lastResponse = response;
      }),
      catchError((err: HttpErrorResponse) => {
        err = err;
        this.loading.forceCloseLoading();
        let message = "";
        console.log(err.url);
        switch (err.status) {
          case 204:
            message = err.error;
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.WARNING_CLASS
            );
            break;
          case 500:
            message = "500_error";
            if (!req?.url.includes("notifications")) {
              if (
                err.url !==
                "https://apim-be.azure-api.net/user/mws-contact/change-password"
              ) {
                if (ErrorInterceptor.tmpDebounceFlag == true) {
                  window.history.go(-1);
                  ErrorInterceptor.tmpDebounceFlag = false;
                } else {

                  const navigationExtras: NavigationExtras = {
                    state: {
                      id: 500
                    },
                  };
                  this.router.navigateByUrl('/user/error', navigationExtras);

                }
              } else {
                this.snack.openSnackReferClassWithTranslationEmbedded(
                  message,
                  SNACKBAR_CLASS.WARNING_CLASS
                );
              }
            }
            break;
          case 417:
            message = "417_error";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            this.auth.logout();
            break;
          case 503:
            message = "503_error";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            /* this.auth.logout(); */
            break;
          case 400:
            message = err.error;
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            //  this.router.navigate(["/user/error"]);
            break;
          case 404:
            this.snack.openSnackReferClassWithTranslationEmbedded(
              this.i18n.getTranslation("service_unavailable_error"),
              SNACKBAR_CLASS.ERROR_CLASS
            );

            break;
          case 401:
            message = "Utente non autorizzato";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            this.router.navigate(["/home"]);
            break;
          case 403:
            message = "Servizio non disponibile";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            break;
          case 420:
            message = "Token scaduto, effettuare nuovamente il login";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            this.auth.logout();
            break;
          case 504:
            message = "Servizio non disponibile";
            this.snack.openSnackReferClassWithTranslationEmbedded(
              message,
              SNACKBAR_CLASS.ERROR_CLASS
            );
            break;
         
          // this.auth.logout();
        }
        const resultObject = { body: null, errors: true };
        return of(new HttpResponse(resultObject));
      }),
      finalize(() => {
        if (lastResponse.type === HttpEventType.Sent && !error) {
          this.loading.forceCloseLoading();
        }
      })
    );
  }
}
